import { json } from '@codemirror/lang-json';
import { markdown, markdownLanguage } from '@codemirror/lang-markdown';
import { languages } from '@codemirror/language-data';
import { EditorView } from '@codemirror/view';

import { customKeyMap } from './keymap';
import { jsonLinter } from '../linters/jsonLinter';
import { createEditorStyle } from '../styles/editorStyles';
import type { LanguageMode } from '../types';

export const createExtensions = (
  language: LanguageMode,
  enableJsonPathSearch: boolean,
  hasError: boolean,
  readOnly: boolean,
  disableJsonValidation: boolean,
  lineWrapping: boolean = false
) => {
  const baseExtensions = [
    customKeyMap,
    readOnly ? EditorView.editable.of(false) : EditorView.editable.of(true),
    createEditorStyle(enableJsonPathSearch, hasError, language, lineWrapping),
    ...(lineWrapping ? [EditorView.lineWrapping] : [])
  ];

  if (language === 'json') {
    return [
      json(),
      ...(disableJsonValidation ? [] : [jsonLinter]),
      ...baseExtensions
    ];
  }

  if (language === 'markdown') {
    return [
      markdown({
        base: markdownLanguage,
        codeLanguages: languages
      }),
      ...baseExtensions
    ];
  }

  return baseExtensions;
};
